'use strict';

orderProduct.$inject = ["textBuilder", "Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderProduct = orderProduct;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function orderProduct(textBuilder, Enums) {
    var clazz = function OrderProduct() {
        var defaults = {
            id: 0,
            type: '',
            name: '',
            productNumber: '',
            promoCode: '',
            productNumberAndPromo: '',
            quantity: '',
            unitPrice: '',
            totalPriceWithoutDiscount: '',
            totalPriceWithDiscount: '',
            discountPercentage: '',
            totalDiscount: '',
            totalDiscountPct: '',
            included_products: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.type = '';
        o.name = resource.displayName;
        o.productNumber = resource.nationalNumber;
        o.promoCode = resource.promoCode;
        o.productNumberAndPromo = textBuilder.getProductNumberAndPromo(o.productNumber, o.promoCode);
        o.quantity = resource.quantity;
        o.unitPrice = resource.price;
        o.discountPercentage = resource.discountPercentage;
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalDiscountAmount = resource.totalDiscountAmount;
        o.totalPriceWithoutDiscount = resource.totalPriceWithDiscount + resource.totalDiscountAmount;
        o.status = resource.status;
        o.hasSuccess = hasSuccess(resource.statusCode);
        o.hasError = hasError(resource.statusCode);
        o.statusCode = resource.status;
        o.reason = resource.reason;
        o.reasonCode = resource.reasonCode;

        if (resource.content && resource.content.length > 0) {
            o.included_products = _lodash2.default.map(resource.content, function (i) {
                return {
                    name: i.displayName,
                    quantity: i.quantity,
                    productNumber: i.nationalNumber,
                    statusCode: i.statusCode
                };
            });
        }
        return o;
    };

    function hasSuccess(code) {
        return code ? code === Enums.orderProductStatusCodes.CONFIRMED.value || code === Enums.orderProductStatusCodes.CON.value : false;
    }

    function hasError(code) {
        return code ? code === Enums.orderProductStatusCodes.ERROR.value || code === Enums.orderProductStatusCodes.CANCELLED.value || code === Enums.orderProductStatusCodes.CAN.value : false;
    }

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/orderProductModel.js
// module id = 765
// module chunks = 0